if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");

  if (!footer) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const widget = document.querySelector('[id^="trustedshops"]');
        if (!widget) return;

        if (entry.isIntersecting) {
          widget.classList.add("ts-visible");
        } else {
          widget.classList.remove("ts-visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(footer);
});
